import React from 'react';
import './Graphique.css';
import Bouton from '../Form/Bouton';

const CarreBilan = ({logo, titre, titregras, totalConsumption, handleContribution}) => {
  // Données pour les éléments du graphique
  const montantDonation = totalConsumption*28

  return (
    <div className='CarreBilanParticulier'>
      <div className='textCarreBilan'>
        <p>
        1 tonne CO₂ évitée
        <br/><br/>
        =
        <br/><br/>
        28€
        <br/><br/>
        Le montant de votre contribution s'élève à {Math.round(montantDonation)} €
        </p>
        <div className="btn-contribuer-wrapper">
          <Bouton titre = "JE CONTRIBUE" onClick={handleContribution} />
        </div>
      </div>
    </div>
  );
};

export default CarreBilan;